export const inserterOptions = [
    {
        label: 'Supporter name',
        value: '%supporter%',
        type: 'supporter',
    },
];
